// Workaround für ein framer-motion/Chrome-Race: WAAPI-Animationen lassen
// style.opacity auf dem Startwert stehen und schreiben den Endwert erst im
// onfinish-Task — Chrome präsentiert dazwischen einen Frame ohne Effekt,
// der Inhalt blitzt für ~1 Frame weg (per CDP-Screencast nachgewiesen,
// Details im Kommentar in src/app/[lang]/template.tsx).
// Ein vorhandenes onUpdate-Prop schaltet framer offiziell auf die
// Main-Thread-Animation um, die jeden Frame inline schreibt.
export const forceMainThreadAnimation = () => {};
